import BaseAPI from '../api'
const path = 'notifications'
export default class NotificationsApi extends BaseAPI {

    static getNotifications(): Promise<any> {
        return this.api.get(`${path}`, {})
            .then((res) => res)
    }

    static deleteNotifications(idNotification: number): Promise<any> {
        return this.api.patch(`${path}/${idNotification}/delete
        `, {})
            .then((res) => res)
    }

}
